import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const AbvMcdPymtActualsSplitGrpForm = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    const periodExpr = ExprUtils.and(
      ExprUtils.whereParams('periodicity', 'MON'),
      ExprUtils.isGreaterOrEqual('code', '2023M03'),
    );
    fieldToFieldDef.startPeriodId.expr = periodExpr;
    fieldToFieldDef.endPeriodId.expr = periodExpr;
  };

  return <EntityForm augFieldDefs={augFieldDefs} />;
};
